const fromdata = [{
	inputdata: "",
	title: "产品线",
	fontSize: "14px",
	color: "#333333",
	placeholder: "全部",
	types: "",
	inputtype: "select",
	width: "280px",
	btx: true,
	options: [],
	event: "invClass",
}, {
	inputdata: "",
	title: "经营省份",
	fontSize: "14px",
	color: "#333333",
	placeholder: "全部",
	types: "",
	inputtype: "selectMultiple",
	width: "280px",
	btx: true,
	options: [],
}, {
	inputdata: "",
	title: "小区经理",
	fontSize: "14px",
	color: "#333333",
	placeholder: "全部",
	types: "",
	inputtype: "selectMultiple",
	width: "280px",
	btx: true,
	options: [],
}, {
	inputdata: "",
	title: "省级经理",
	fontSize: "14px",
	color: "#333333",
	placeholder: "全部",
	types: "",
	inputtype: "selectMultiple",
	width: "280px",
	btx: true,
	options: [],
}];
export default fromdata;